import {  useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AppDispatch, RootState } from 'redux/store'
import { clearAllFilters, setKpiStudent, setKpiSubject, setSearch } from 'redux/ui/kpiEvaluationsUI'

import PageHeading from 'components/atoms/PageHeading'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import MainTable from 'components/organisms/tables/MainTable'
import ExtraFilters from 'components/organisms/forms/tableFilters/kpiEvaluations/ExtraFilters'

import formModel, { initialValues } from 'utils/tableFilterModels/kpiTableFilterModel'
import { useTableModel } from 'utils/tableModels/useKpiEvaluationsTableModel'

import { kpiEvaluationsAPI, useGET_kpiEvaluationsQuery } from 'redux/api/kpiEvaluationsApi'
import { useEffect } from 'react'
import { Box, Grid } from '@mui/material'
import { useGET_learningStyleQuestionsQuery, useGET_studentByProfileIdQuery } from 'redux/api/studentsApi'
import StudentCard from 'components/utilized/students/studentCard'
import KpiPerformanceChart from 'components/utilized/kpi/KpiPerformanceChart'
import DialogPopup from 'components/molecules/DialogPopup'
import KpiStudent from 'components/utilized/kpi/KpiStudent'
import { Legend, PieChart, ResponsiveContainer } from 'recharts'
import BenchmarkPerformanceChart from 'components/utilized/benchmarks/BenchmarkPerformanceChart'


const KpiEvaluationsPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'kpiEvaluations'

  const user = useSelector((state: RootState) => state['user'].user)
  
  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)
  const filters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    category: useSelector((state: RootState) => state[reduxKey].tableFilters.category),
    group: useSelector((state: RootState) => state[reduxKey].tableFilters.group),
    student: useSelector((state: RootState) => state[reduxKey].tableFilters.student),
    created_at_after: useSelector((state: RootState) => state[reduxKey].tableFilters.created_after),
    created_at_before: useSelector((state: RootState) => state[reduxKey].tableFilters.created_before),
  }

  useEffect(() => { 
    dispatch(clearAllFilters())
  }, [])

  const {data: studentData} = useGET_studentByProfileIdQuery(filters.student,{skip: !filters.student})
  
  
  const {
    data: learningStyle,
  } = useGET_learningStyleQuestionsQuery(filters.student, {skip: !filters.student})
        
  const kpiSubject = useSelector((state: RootState) => state['kpiEvaluations'].kpiSubject)
  const kpiStudent = useSelector((state: RootState) => state['kpiEvaluations'].kpiStudent)
  

  return (
    <>
      <PageHeading title={t('common.kpi-tracker')} />


      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_kpiEvaluationsQuery}
        filters={filters}
        header={
          <>
            <MainTableFiltersForm
              reduxKey={reduxKey}
              tag="kpi-evaluations"
              entityName={t('common.kpi-tracker')}
              api={kpiEvaluationsAPI}
              setSearch={setSearch}
              clearAllFilters={clearAllFilters}
              formModel={formModel}
              initialValues={initialValues}
              activeFilters={activeFilters}
              openFilters
              hideDefaultActions
              >
               <ExtraFilters hideStudentFields={user?.role==='parent'}/>
          </MainTableFiltersForm>

          
          {filters.student && studentData && <Box mt={1} mb={3}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={4}><StudentCard student={studentData} learningStyle={learningStyle} step={1}/></Grid>
                  <Grid item xs={12} md={8}>
                      <KpiPerformanceChart filters={filters}/>
                  </Grid>
                </Grid>
            </Box>}


            {filters.group && !filters.student && <Box mt={1} mb={3}>
                <BenchmarkPerformanceChart filters={filters}/>
            </Box>}


          </>
        }
      />

      
      {kpiStudent && kpiSubject && <DialogPopup
          title={t('common.kpi-tracker')}
          onClose={() => {
            dispatch(setKpiSubject(null))
            dispatch(setKpiStudent(null))
          }}
          open
          popupWidth={'1400px'}
          popupPadding={0}
        >
          <KpiStudent student={kpiStudent} subject={kpiSubject} />
      </DialogPopup>}
    </>
  )
}
export default KpiEvaluationsPage
